import dayjs from 'dayjs';
// import utc from 'dayjs/plugin/utc';
// import timezone from 'dayjs/plugin/timezone';
import 'dayjs/locale/sv';

export const dayjsSetup = () => {
  dayjs.locale('sv');
  // TODO: Use this settings and test everywhere so that datepickers wont break up...
  // dayjs.extend(utc);
  // dayjs.extend(timezone);
  // dayjs.tz.setDefault('Europe/Stockholm');
};
